import { createFileRoute } from '@tanstack/react-router';
import { PortalDetailsStepForm } from './-components/portal-new-steps/details-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/setup/details')({
	component: PortalDetailsStepForm,
});
